<kendo-dialog *ngIf="pedido" (close)="feche()" [minWidth]="320" [width]="840">
  <div class="comissionamento-modal">
    <div class="comissionamento-header">
      <span class="comissionamento-header-icon"><i class="fas fa-clipboard-list"></i></span>
      <h4>Comissionamento do pedido</h4>
      <button type="button" class="comissionamento-close" (click)="feche()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="comissionamento-body">
      <div class="comissionamento-meta">
        <span class="comissionamento-meta-icon"><i class="fas fa-shopping-bag"></i></span>
        <span>Pedido</span>
        <strong>{{pedido.codigo}}</strong>
        <span class="comissionamento-divider"></span>
        <i class="fas fa-user comissionamento-user-icon"></i>
        <strong class="comissionamento-cliente" *ngIf="pedido.cliente?.nome">
          {{pedido.cliente.nome}}
        </strong>
        <span class="comissionamento-count ml-auto">
          {{itensComissionamento.length}} {{itensComissionamento.length === 1 ? 'item' : 'itens'}} para comissionar
        </span>
      </div>

      <div class="alert alert-danger mb-3" *ngIf="erro">{{erro}}</div>
      <div class="text-center p-3" *ngIf="carregando">
        <i class="k-i k-i-loading"></i>
      </div>

      <div class="alert alert-info mb-2" *ngIf="!carregando && !itensComissionamento.length">
        Este pedido não possui itens com produto com comissão ativa.
      </div>

      <div class="form-group" *ngIf="deveExibirJustificativa()">
        <label class="mb-1">Justificativa da troca</label>
        <textarea class="form-control" rows="2"
                  [(ngModel)]="justificativa"
                  placeholder="Obrigatória para trocar {{labelOperacionalSingular() | lowercase}} depois do pedido entregue"></textarea>
      </div>

      <div class="comissionamento-card" *ngFor="let item of itensComissionamento">
        <div class="comissionamento-produto">
          <span class="comissionamento-produto-icon"><i class="fas fa-cube"></i></span>
          <div>
            <strong>{{item.produtoNome}}</strong>
            <div class="text-muted">
              {{item.quantidade}}x - {{item.comissaoNome}} - {{item.valorComissaoFixa | currency:'BRL'}}
            </div>
          </div>
        </div>

        <div class="comissionamento-separador"></div>

        <div class="comissionamento-form">
          <div class="comissionamento-select-wrap">
            <select class="form-control comissionamento-select" [(ngModel)]="item.comissionadoId">
              <option [ngValue]="null">Selecione um {{labelOperacionalSingular() | lowercase}}</option>
              <option *ngFor="let comissionado of comissionados" [ngValue]="comissionado.id">
                {{comissionado.nome}}
              </option>
            </select>
            <small>Escolha o responsável pela comissão deste item.</small>
          </div>
          <button class="btn comissionamento-salvar"
                  [disabled]="salvando || !item.comissionadoId"
                  (click)="salveComissionadoItem(item)">
            <i class="fas fa-save mr-2" *ngIf="!salvando"></i>
            <i class="k-i k-i-loading mr-2" *ngIf="salvando"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <div class="comissionamento-footer">
      <button type="button" class="btn btn-light btn-block" (click)="feche()">Fechar</button>
    </div>
  </div>
</kendo-dialog>
